module.exports = __webpack_public_path__ + "6d715e5e126bc8a0e966e84594cb5476.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_stacked_bar_1day_show_thresholds.png
// module id = 876
// module chunks = 7